import React from "react";
import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "The Lone Path",
    body:
      "Greatness was never built in a crowd. It was forged alone, under the same iron, in rooms nobody photographed. We make gear for that room.",
  },
  {
    n: "02",
    title: "Matte. Not Loud.",
    body:
      "No neon. No noise. A gloss-black wolf on matte-black fabric — visible only to those who already know. The work speaks. The logo whispers.",
  },
  {
    n: "03",
    title: "Engineered To Vanish",
    body:
      "Seamless construction, weighted drape, zero distraction. The best gear is the gear you forget you're wearing until the last rep tells you otherwise.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 },
  }),
};

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="relative bg-[#050505] py-28 md:py-40 overflow-hidden">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl mb-20 md:mb-28"
      >
        <span className="font-sans text-[11px] tracking-[0.45em] text-white/40">THE CODE</span>
        <h2 className="mt-6 font-display font-black uppercase tracking-normal leading-[0.9] text-white text-5xl md:text-7xl">
          Built on purpose.
          <br />
          Worn with intent.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.n}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="group relative bg-[#050505] p-10 md:p-12 min-h-[340px] flex flex-col justify-between overflow-hidden"
          >
            <span className="absolute -top-6 -right-2 font-display font-black text-[9rem] leading-none text-white/[0.04] group-hover:text-white/[0.07] transition-colors duration-500 select-none">
              {c.n}
            </span>
            <span className="relative font-sans text-xs tracking-[0.3em] text-white/40">CHAPTER {c.n}</span>
            <div className="relative mt-auto">
              <h3 className="font-display font-extrabold uppercase tracking-normal text-3xl text-white mb-4">
                {c.title}
              </h3>
              <p className="font-sans text-sm text-white/60 leading-relaxed max-w-xs">{c.body}</p>
            </div>
            <span className="absolute bottom-0 left-0 h-px w-0 bg-white group-hover:w-full transition-all duration-700" />
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
